import { createContext, type ReactNode, useCallback, useContext, useRef, useState } from 'react';

const ToastContext = createContext<(text: string) => void>(() => {});

/** Short confirmations above the bottom edge ("Скопійовано", "Ціну оновлено в 3 постах"). */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [text, setText] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);
  const show = useCallback((next: string) => {
    clearTimeout(timer.current);
    setText(next);
    timer.current = setTimeout(() => setText(null), 2_200);
  }, []);
  return (
    <ToastContext.Provider value={show}>
      {children}
      {text && (
        <div
          role="status"
          className="pointer-events-none fixed inset-x-0 bottom-[calc(var(--toast-bottom,96px)+env(safe-area-inset-bottom))] z-50 flex justify-center px-4 animate-[fade-in_150ms_ease-out]"
        >
          <div className="rounded-xl bg-black/80 px-4 py-2.5 text-[15px] text-white">{text}</div>
        </div>
      )}
    </ToastContext.Provider>
  );
}

export function useToast(): (text: string) => void {
  return useContext(ToastContext);
}
